import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`是一個相信藉由產品可以為使用者的人生帶來不一樣轉變的人。本身經歷從 QA 轉 RD 而後轉至 PM ，喜歡且善於分析、改善流程。在工作上的職務是一位 PM，但對於自己的定位則不只是 PM，持續學習與實踐任何可以對於自己、產品甚至是團隊上，可以變得更好的方法，並希望藉由自身的實踐影響更多人，讓更多的人再去影響更多人。`}</p>
    <p>{`Linkedin: `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/pmsylvia"
      }}>{`https://www.linkedin.com/in/pmsylvia`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      